import { Button, Dialog, Loading } from '@startlibs/components';
import {useToggle} from '@startlibs/core'
import React from 'react'
import styled from 'styled-components';

import { AttachmentBox } from './AttachmentBoxStyles';

const ProcessingBoxComponent = styled(AttachmentBox)`
  padding: 0.75rem 1.5rem 0.75rem 1.5rem;
  justify-content: center;
  font-weight: 600;
  min-height: 3rem;
  div {
    margin-right: 0.75rem;
  }
`

export const ProcessingBox = ({unprocessedFiles,setUnprocessedFiles,cancelProcessDialog}) => {


  const cancelQueue = () => {
    cancelProcessDialog.close()
    setUnprocessedFiles([])
  }

  return <ProcessingBoxComponent>
    <Loading size={18} borderWidth={3}/><div>Processing files...</div>
    {unprocessedFiles.length > 1 && <a className="link" onClick={cancelProcessDialog.open}>Cancel</a>}
    {
      cancelProcessDialog.isOpen &&
        <Dialog
          closeDialog={cancelProcessDialog.close}
          title="Are you sure you wish to cancel the upload?"
          css="max-width:52rem;"
          footer={<>
            <Button onClick={cancelProcessDialog.close}>Continue file processing</Button>
            <Button alert onClick={cancelQueue}>Cancel queued file processing</Button>
          </>}
        >
<p>You are about to cancel the upload.</p>
<p><b>If you do so, incomplete DICOM studies may result.</b></p>
<p>We suggest that you wait for file processing to finish or that you delete your DICOM studies and upload them again afterwards to make sure they are complete.</p>
<p>Files that have already finished uploading will remain in your medical records list unless you delete them manually.</p>
        </Dialog>
    }
  </ProcessingBoxComponent>
}
